import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";


export function loginErp(type){
  return http.get("/index/login",{type,name:"1",pwd:"1"});
}
//监控
export function alarmNameV1(){
    return http.get("/exception/option");
  }
  export function alarmNameV2(params){
    return http.get("/alarm/getCascade",params);
  }
  // 告警名称
  // /device/getByAbnormalName
  export function getName(){
    return http.get("/device/getByAbnormalName");
  }
  // /alarm/findPage
  export function queryList(page, params) {
    return http.postJSON("/alarm/findPage?" + jsonToFormData(page), params)
  }
  export const insert=(params)=> {
    return http.postJSON("/alarm/insert",params)
  }
  export function updateStatus(params) {
    return http.postJSON("/alarm/update",params)
  }
  export function alarmNameV3(){
    return http.get("/exception/option3");
  }


// WEBPACK FOOTER //
// ./src/services/alarmRemind.js